export default "__VITE_ASSET__0c1335fa__"